import {ReferenceType} from '@shared/references.model';

export class CustomerTypeFilter {
  categories: ReferenceType [];
  name: string;
}
